// extracted by mini-css-extract-plugin
export default {"feedContainer":"feed_feedContainer__Hjzno","scrollContainerStyles":"feed_scrollContainerStyles__9Ujwb"};